import { styled } from '@clickcease/cc-client-components-lib'

export const Wrapper = styled('div', {
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
})

export const ContentWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
})

export const Title = styled('h2', {
  maxWidth: '480px',
  marginBottom: '$8',
  marginTop: '0',
  fontSize: '2.625rem',
  fontWeight: '$sb',
})

export const Description = styled('span', {
  maxWidth: '472px',
  marginBottom: '$12',
  fontSize: '$h5',
  fontWeight: '$l',
})

export const SmallText = styled('span', {
  fontSize: '$md',
  fontWeight: '$l',
  variants: {
    disclaimer: {
      true: {
        marginTop: '$16',
        marginBottom: '0',
      },
    },
    quick_setup: {
      true: {
        marginTop: '$4',
      },
    },
  },
})

export const Image = styled('img', {
  display: 'flex',
  maxWidth: '50%',
  boxShadow: `0px 0px 20px rgba(225, 36, 104, .1)`,
  '@bp5': {
    maxHeight: 'unset !important', // important is needed to override the inline style
  },
})

export const ApiApprovedWrapper = styled('div', {
  display: 'flex',
  marginTop: '$12',
  gap: '$3',

  ':nth-child(2)': {
    height: '16px',
    width: '16px',
  },
})
